<template>
    <div v-if="openModal" class="modals bgAzul" style="background-color: rgba(0, 0, 0, 0.6); z-index:8888">
        <div v-on:click="closeModal" style="z-index: -1;width: 100%; height: 100%; position: fixed; top: 0px; left: 0px;"></div>
        <div class="main_modal">
            <div class="header_modal">
                <span>{{ this.$i18n.t('mural.titulo') }}</span>
                <a href="#" class="close" data-response="0" style="float: right; cursor: pointer;" v-on:click="closeModal">
                    <img src="assets/icons/modals/x.svg" alt="">
                </a>
            </div>
            <div class="body_modal">
                <form id="post_form">
                    <span class="title_modal">{{ this.$i18n.t('mural.titulo-form') }}</span>
                    <div class="type_selector">
                        <span class="selector_item id_type_0" @click="changeType('gallery')" id="type_gal" style="margin-right: 15px;">{{ this.$i18n.t('mural.galeria') }}</span>
                        <span class="selector_item id_type_0" @click="changeType('webcam')" id="type_web" style="margin-left: 15px; margin-right: 15px;">{{ this.$i18n.t('mural.webcam') }}</span>
                        <span class="selector_item id_type_2" @click="changeType('upload')" id="type_up" style="margin-left: 15px; margin-right: 15px;">{{ this.$i18n.t('mural.upload') }}</span>
                        <span class="selector_item id_type_1" @click="changeType('text')" id="type_text" style="margin-left: 15px;">{{ this.$i18n.t('mural.texto') }}</span>
                    </div>

                    <div class="form_modal" id="forms_fields">
                        <div id="gal_form">
                            <div v-if="selfies != null">
                                <div v-for="(selfie, index) in selfies.selfies" class="gal-items" :key="index">
                                    <img v-for="element in selfie" :key="element.id" v-on:click="chooseImage(element.id)" :id="element.gallery" :src="element.path">
                                </div>
                            </div>
                        </div>
                        <div id="web_form">
                            <div id="webcam-photo-content" ref="webcam-photo-content">
                                <video id="webcam-photo-video"></video>
                                <canvas id="webcam-photo-canvas" style="display: none;"></canvas>
                            </div>
                            <div class="web_buttons">
                                <a href="#" id="web_take" v-on:click="webCamCapture"
                                        style="display:inline;padding: 10px 0">
                                            <img :src="$url + 'assets/img/webcam/take_photo.png'" style="height: 30px;" alt="Tirar foto"/>
                                        </a>
                                <a href="#" id="web_discard" v-on:click="webCamDiscard" style="display: none;padding: 10px 0">
                                    {{ this.$i18n.t('mural.tirar-foto') }}
                                </a>
                            </div>
                        </div>
                        <div id="up_form">
                            <img id="upload_image" width="368" height="155" style="display: none; object-fit: scale-down;" v-on:click="openUpload">
                            <div class="area-upload" id="area-upload">
                                <label for="upload-file" class="label-upload">
                                    <div>
                                        <svg width="164" height="63" viewBox="0 0 164 63" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <rect width="164" height="63" fill="url(#pattern0)" fill-opacity="0.6"/>
                                        <defs>
                                        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                        <use xlink:href="#image0_406_325" transform="translate(0.307927) scale(0.00170732 0.00444444)"/>
                                        </pattern>
                                        <image id="image0_406_325" width="225" height="225" xlink:href="data:image/png;base64,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"/>
                                        </defs>
                                    </svg>
                                    </div>
                                    <div class="texto">{{ this.$i18n.t('mural.upload-text-1') }}&nbsp;<br>&nbsp;{{ this.$i18n.t('mural.upload-text-2') }}</div>
                                </label>
                                <input v-on:change="uploadPhoto" type="file" accept="image/jpg,image/png,image/gif,image/x-ms-bmp" id="upload-file"/>
                                
                                <div class="lista-uploads">
                                </div>
                            </div>
                        </div>
                        <div class="type_text" id="text_form">
                            <img src="/assets/images/mural/no_image.png" alt="" style="width:368px;">
                        </div>
                    </div>
                    <div class="text_modal">
                        <span class="text_title">{{ this.$i18n.t('mural.texto-detalhes') }}</span>
                        <span class="text_count" id="text_count">0/250</span>
                        <div class="text_detail">
                            <textarea maxlength="250" required v-on:input="verifyCount" name="post_detail" id="post_detail" ref="postDetails" rows="3"></textarea>
                        </div>
                    </div>
                </form>
                <div id="confirm_modal" class="confirm_modal">
                    <span class="title_modal">Sua postagem</span>
                    <div class="image_confirm">
                        <img id="image_confirm">
                    </div>
                    <div class="detail_post">
                        <span class="user_details"><b>{{ nickname }}</b> - <span id="time"></span> {{ this.$i18n.t('mural.escreveu') }}:</span>
                        <br>
                        <div class="user_text">{{ this.postMessage }}</div>
                    </div>
                </div>
            </div>
            <div class="footer_modal">
                <button disabled v-on:click="next" type="button" class="next" id="next_button">{{ this.$i18n.t('mural.proximo') }}</button>
                <button v-on:click="previous" type="button" class="previous" id="previous_button" style="display: none; margin-right: 6px;">{{ this.$i18n.t('mural.modificar') }}</button>
                <button v-on:click="publish" type="button" class="next"  id="publish_button" style="display: none;">{{ this.$i18n.t('mural.publicar') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {mapActions, mapGetters} from "vuex";

export default {
        name: 'Mural',
        computed: {
            ...mapGetters([
                'logged', 'token','switch', 'nickname','event_id'
            ]),
        },
        data() {
            return {
                openModal:false,
                formType:'gallery',
                counterLength:0,
                postMessage: null,
                webcam_video: null,
                webcam_canvas: null,
                webcam_canvas_context: null,
                webcam_stream: null,
                webcam_type: null,
                webcam_photo: null,
                upload_photo: false,
                gallery_photo: null,
                hasPhoto: false,
                selfies: null,
                upload_file: null,
                idType: null,
                modalRendered: false
            }
        },  
        components: {
            
        },
        methods: {
            ...mapActions([
                'update_notification_with_id'
            ]),
            openUpload(){
                document.getElementById('upload-file').click();
            },
            chooseImage(id){
                var image = document.getElementById('gallery_'+id);
                image.classList.add('gal-active');
                this.gallery_photo = image.src;
                var selfies = this.selfies.selfies;
                selfies.forEach(selfie => {
                    selfie.forEach(element => {
                        if(id != element.id) {
                            document.getElementById('gallery_'+element.id).classList.remove('gal-active');
                        }
                    });
                });
                this.checkForNext();
            },
            webCamPause()
            {
                if(this.webcam_video != null) {
                    this.webcam_video.pause();
                    this.webcam_stream.getTracks().forEach((track) => track.stop());
                    this.webcam_video.srcObject = null;
                }
                return;
            },
            async popGallery()
            {
                if(this.openModal && this.selfies == null) {
                    var root_ = this;
                    const response = await axios.get(this.$url_api + "api/mural/selfies-list",
                            {
                                headers:{'language': this.$i18n.locale,'Authorization': `Bearer ${root_.token}`},
                            }
                        );
                        this.popGalleryResponse(response.data);
                }
            },
            popGalleryResponse(data){
                var div = document.getElementById('gal_form');
                if(data.selfies.length < 1) {
                    div.innerHTML = `<div class="loading_image" style="text-align:center;height:69px;padding-top:69px;font-size: 10px;color: #999;display: flex;justify-content: center;text-align: center;">${this.$i18n.t('mural.no-image')}</div>`
                } else {
                    this.selfies = data;
                    console.log(this.selfies);
                }
            },
            popGalleryError(data){
                data
            },
            webCamStart() {
                let root_ = this;

                navigator.mediaDevices
                    .getUserMedia({video: {width: 368, height: 138}})
                    .then(function (mediaStream) {
                        root_.webcam_stream = mediaStream;
                        root_.webcam_video = document.querySelector("#webcam-photo-video");
                        root_.webcam_video.srcObject = mediaStream;
                        root_.webcam_video.play();
                    })
                    .catch(function (err) {
                        err;
                    });
            },
            webCamCapture(e) {
                e;
                this.webcam_canvas = document.querySelector("#webcam-photo-canvas");
                this.webcam_canvas.height = 138;
                this.webcam_canvas.width = 368;
                this.webcam_canvas_context = this.webcam_canvas.getContext("2d");
                this.webcam_canvas_context.drawImage(this.webcam_video, 0, 0);
                this.webcam_photo = this.webcam_canvas.toDataURL("image/jpeg");
                this.webcam_video.style.display = 'none';
                this.webcam_canvas.style.display = 'block';


                document.getElementById("web_take").style.display = "none";
                document.getElementById("web_discard").style.display = "inline";
                this.webCamPause();
                this.checkForNext();
            },
            webCamDiscard(e) {
                e;

                this.webcam_canvas_context.clearRect(
                    0,
                    0,
                    this.webcam_canvas.width,
                    this.webcam_canvas.height
                );
                this.webcam_video.style.display = 'block';
                this.webcam_canvas.style.display = 'none';

                this.webcam_photo = null;

                document.getElementById("web_take").style.display = "inline";
                document.getElementById("web_discard").style.display = "none";
                this.webCamStart();
                this.checkForNext();
            },
            previous()
            {
                var nextButton = document.getElementById('next_button');
                var previousButton = document.getElementById('previous_button');
                var publishButton = document.getElementById('publish_button');
                var confirm = document.getElementById('confirm_modal');
                var form = document.getElementById('post_form');
                nextButton.style.display = 'inline';
                previousButton.style.display = 'none';
                publishButton.style.display = 'none';
                confirm.style.display = 'none';
                form.style.display = 'block';
                this.checkForNext();
            },
            publish()
            {
                this.$app.wait(true);
                var form = new FormData();
                switch (this.formType) {
                    case 'gallery':
                        form.append('type', 'gallery');
                        form.append('idType', 0);
                        form.append('image', this.gallery_photo);
                        break;
                    case 'webcam':
                        form.append('type', 'webcam');
                        form.append('idType', 0);
                        form.append('image', this.webcam_photo);
                        break;
                    case 'upload':
                        form.append('type', 'upload');
                        form.append('idType', 2);
                        form.append('image', this.upload_file);
                        break;
                    case 'text':
                        form.append('type', 'text');
                        form.append('idType', 1);
                        break;
                }
                form.append('detail', this.postMessage);
                form.append('event_id', this.event_id);

                let headers = {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access': 'application/json',
                    language: this.$i18n.locale, Authorization: `Bearer ${this.token}`
                };
                axios.post(`${this.$url_api}api/mural/post-store`, form, {headers: headers})
                    .then(response => this.publishResponse(response))
                    .catch(error => this.publishError(error));
            },
            publishResponse(response){
                response;
                this.$app.wait(false);
                this.closeModal();
                this.$app.modal('success', this.$i18n.t('mural.sucesso'), this.$i18n.t('mural.sucesso-message'), null, null, null, "OK");
            },
            publishError(error){
                error;
                let str = this.$i18n.t('mural.erro-message')
                this.$app.wait(false);
                this.$app.modal('error', this.$i18n.t('mural.erro'), str, null, null, null, "OK");
            },
            closeModal()
            {
                this.webCamPause();
                this.formType = 'gallery';
                this.counterLength = 0;
                this.openModal = false;
                this.hasPhoto = false;
                this.webcam_video = null;
                this.webcam_canvas = null;
                this.webcam_canvas_context = null;
                this.webcam_stream = null;
                this.webcam_type = null;
                this.webcam_photo = null;
                this.gallery_photo = null;
                this.upload_photo = false;
                this.upload_file = null;
                this.postMessage = null;
                this.selfies = null;
            },
            checkForNext()
            {
                var button = document.getElementById('next_button')
                
                switch (this.formType) {
                    case 'gallery':
                        if(this.gallery_photo != null){
                            if(this.counterLength > 0) {
                                button.disabled = false;
                            } else {
                                button.disabled = true;
                            }
                        } else {
                            button.disabled = true;
                        }
                        break;
                    case 'webcam':
                        if(this.webcam_photo != null){
                            if(this.counterLength > 0) {
                                button.disabled = false;
                            } else {
                                button.disabled = true;
                            }
                        } else {
                            button.disabled = true;
                        }
                        break;
                    case 'upload':
                        if(this.upload_photo){
                            if(this.counterLength > 0) {
                                button.disabled = false;
                            } else {
                                button.disabled = true;
                            }
                        } else {
                            button.disabled = true;
                        }
                        break;
                    case 'text':
                        if(this.counterLength > 0) {
                            button.disabled = false;
                        } else {
                            button.disabled = true;
                        }
                        break;
                }
            },
            getTime()
            {
                var fullDate = new Date();
                var formatDate = fullDate.toLocaleDateString() + ' às ' + fullDate.toLocaleTimeString();
                document.getElementById('time').innerText = formatDate;
            },
            next(){
                var nextButton = document.getElementById('next_button');
                var previousButton = document.getElementById('previous_button');
                var publishButton = document.getElementById('publish_button');
                var form = document.getElementById('post_form');
                var image = document.getElementById('image_confirm');
                var confirm = document.getElementById('confirm_modal');
                this.getTime();
                if(this.counterLength > 0) {
                    nextButton.style.display = 'none';
                    previousButton.style.display = 'inline';
                    publishButton.style.display = 'inline';
                    form.style.display = 'none';
                    confirm.style.display = 'block';
                    this.webCamPause();
                    switch (this.formType) {
                        case 'gallery':
                            image.src=this.gallery_photo;
                            break;
                        case 'webcam':
                            image.src=this.webcam_photo;
                            break;
                        case 'upload':
                            image.src=document.getElementById('upload_image').src;
                            break;
                        case 'text':
                            image.src='/assets/images/mural/no_image.png';
                            break;
                    }
                } else {
                    nextButton.style.display = 'inline';
                    previousButton.style.display = 'none';
                    publishButton.style.display = 'none';
                    form.style.display = 'block';
                    confirm.style.display = 'none';
                    nextButton.disabled = true;
                    return;
                }
            },
            uploadPhoto(ev){
                var img = document.getElementById('upload_image');
                var drag = document.getElementById('area-upload')
                var up_form_size = document.getElementById('up_form');
                var file = ev.target.files[0];
                if(!file) {
                    this.checkForNext();
                    return;
                }
                var validate = this.validateFile(file);
                if(validate) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        img.src = e.target.result;
                        img.style.width= '368px';
                        img.style.height= '155px';
                    };
                    reader.readAsDataURL(file);
                    img.style.display = 'block';
                    drag.style.display = 'none';
                    this.upload_file = file;
                    this.upload_photo = true;
                } else {
                    img.style.display = 'none';
                    drag.style.display = 'block';
                    this.upload_file = null;
                    this.upload_photo = false
                }
                up_form_size.style.height = '138px'
                this.checkForNext();
                return;
            },
            validateFile(file){
                var mime_types = [ 'image/jpeg', 'image/png', 'image/gif', 'image/x-ms-bmp' ];
                
                if(mime_types.indexOf(file.type) == -1) {
                    return false;
                }

                // Apenas 20MB é permitido
                if(file.size > 20*1024*1024) {
                    return false;
                }

                return true;
            },
            changeType(type){
                var forms = document.getElementById('forms_fields');
                var gallery = document.getElementById("type_gal");
                var galleryForm = document.getElementById("gal_form");
                var webcam = document.getElementById("type_web");
                var webcamForm = document.getElementById("web_form");
                var upload = document.getElementById("type_up");
                var uploadForm = document.getElementById("up_form");
                var text = document.getElementById("type_text");
                var textForm = document.getElementById("text_form");
                switch (type) {
                    case 'gallery':
                        forms.style.marginBottom = 0;
                        this.popGallery();
                        this.formType = 'gallery';
                        gallery.classList.add('selector_active');
                        galleryForm.style.display = 'block';
                        webcam.classList.remove('selector_active');
                        webcamForm.style.display = 'none';
                        upload.classList.remove('selector_active');
                        uploadForm.style.display = 'none';
                        text.classList.remove('selector_active');
                        textForm.style.display = 'none';
                        this.webCamPause();
                        break;
                    case 'webcam':
                        this.formType = 'webcam';
                        gallery.classList.remove('selector_active');
                        galleryForm.style.display = 'none';
                        webcam.classList.add('selector_active');
                        webcamForm.style.display = 'block';
                        webcamForm.style.height = '138px';
                        upload.classList.remove('selector_active');
                        uploadForm.style.display = 'none';
                        text.classList.remove('selector_active');
                        textForm.style.display = 'none';
                        if(this.webcam_photo != null) {
                            document.getElementById("web_take").style.display = "none";
                            document.getElementById("web_discard").style.display = "inline";
                            this.webCamPause();
                        } else {
                            document.getElementById("web_take").style.display = "inline";
                            document.getElementById("web_discard").style.display = "none";
                            this.webCamStart();
                        }
                        break;
                    case 'upload':
                        
                        forms.style.marginBottom = 0;
                        this.formType = 'upload';
                        gallery.classList.remove('selector_active');
                        galleryForm.style.display = 'none';
                        webcam.classList.remove('selector_active');
                        webcamForm.style.display = 'none';
                        upload.classList.add('selector_active');
                        uploadForm.style.display = 'block';
                        uploadForm.style.width = '100%';
                        uploadForm.style.height = '128px';
                        text.classList.remove('selector_active');
                        textForm.style.display = 'none';
                        if (document.getElementById('upload_image').style.display != 'none') {
                            console.log('chegando')
                            uploadForm.style.height = '138px';
                        }
                        this.webCamPause();
                        break;
                    case 'text':
                        forms.style.marginBottom = 0;
                        this.formType = 'text';
                        gallery.classList.remove('selector_active');
                        galleryForm.style.display = 'none';
                        webcam.classList.remove('selector_active');
                        webcamForm.style.display = 'none';
                        upload.classList.remove('selector_active');
                        uploadForm.style.display = 'none';
                        text.classList.add('selector_active');
                        textForm.style.display = 'block';
                        this.webCamPause();
                        break;
                }
                this.checkForNext();
                return;
            },
            verifyCount(event){
                var count = event.target.value.length;
                this.counterLength = count;
                this.checkForNext();
                var counter = document.getElementById("text_count");
                var field = document.getElementById("post_detail");
                document.getElementById("text_count").innerHTML=count+'/250';
                if(count == 0) {
                    this.postMessage = null;
                    field.disabled = false;
                    field.style.borderColor = "red";
                    counter.style.color = "#000";
                    document.getElementById("text_count").style.color = "#000";
                    return;
                }
                if(count > 0 && count < 251) {
                    this.postMessage = event.target.value;
                    field.disabled = false;
                    field.style.borderColor = "#1c1c1c";
                    if(count == 250) {
                        counter.style.color = "red";
                    } else {
                        counter.style.color = "#000";
                    }
                    return;
                }
                if(count > 250) {
                    this.postMessage = event.target.value;
                    field.disabled = true;
                    field.style.borderColor = "red";
                    counter.style.color = "red";
                    return;
                }
            },
            open(idType = null){
                this.idType = idType;
                this.openModal = true;
            },
            getTypeString(idType) {
                switch(idType) {
                    case '1':
                        return 'text';
                    case '2':
                        return 'upload';
                    default:
                        return 'gallery';
                }
            }
        },
        created() {
            if(this.selfies == null) {
                    this.popGallery();
                }
        },
        mounted() {
            this.modalRendered = true;
        },
        updated() {
            if(this.openModal){
                this.changeType(this.formType);
                let drop_ = document.querySelector('.area-upload #upload-file');
            
                drop_.addEventListener('dragenter', function(){
                    document.querySelector('.area-upload .label-upload').classList.add('highlight');
                });
                drop_.addEventListener('dragleave', function(){
                    document.querySelector('.area-upload .label-upload').classList.remove('highlight');
                });
                drop_.addEventListener('drop', function(){
                    document.querySelector('.area-upload .label-upload').classList.remove('highlight');
                });
            }

            if (this.modalRendered) {
                let typeId = this.idType;
                let elements = document.querySelectorAll('.selector_item');
                if (typeId) {
                    elements.forEach(element => {
                        if (element.classList.contains('id_type_' + typeId)) {
                            element.style.display = 'flex';
                        } else {
                            element.style.display = 'none';
                        }
                    });
                    this.changeType(this.getTypeString(typeId));
                }
            }
        },
        beforeDestroy() {
            this.closeModal();
        },
    }
</script>

<style scoped>
    .loading_image {
        font-size: 10px;
        color: #999;
        display: flex;
        justify-content: center;
        text-align: center;
    }
    
    .gal-items img{
        min-width: 32%;
        max-width: 32%;
        min-height: 120px;
        max-height: 120px;
        border: 1px solid #1c1c1c90;
        cursor: pointer;
        opacity: 0.5;
        object-fit: scale-down;
    }
    .gal-active{
        outline: 3px solid #33BCEE;
        outline-offset: -3px;
        opacity: 1 !important;
        cursor: default !important;
    }
    #gal_form {
        display: block;
        height: 138px;
        overflow-y: auto;
    }
    .detail_post {
        margin-top: 25px;
    }
    .user_details {
        font-weight: 400;
        font-size: 16px;
    }
    #web_form {
        display:none;
    }
    .user_details #time {
        font-size: 15px;
    }
    .selector_item {
        cursor:pointer;
    }
    .confirm_modal {
        display: none;
    }
    .user_text {
        margin-top: 10px;
        font-size: 14px;
    }
    .web_buttons {
        text-align: center;
        width: 350px;
        padding: 10px;
        position: absolute;
    }
    #webcam-photo-video {
        width: 100%;
        height: 138px;
        object-fit: cover;
    }
    #web_take {
        display: inline;
        padding: 10px 0px;
    }
    .type_text {
        max-width: 438px;
        max-height: 138px;
        object-fit: scale-down;
    }
    .image_confirm {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        height: 178px;
        max-width: 370px;
        min-width: 370px;
        border: 1px solid #1c1c1c90;
        border-radius: 5px;
    }
    .image_confirm img {
        object-fit: scale-down;
        width: 100%;
        height: 100%;
    }
    .form_modal{
        margin-bottom: 0px;
    }
    .footer_modal {
        width: 100%;
        text-align: center;
        margin: 25px 0;
    }
    .footer_modal .next{
        padding: 15px 55px;
        border: none;
        border-radius: 7px;
        background-color: var(--buttons_color);
        color: var(--fonts_color);
        font-weight: 700;
    }
    .footer_modal .previous{
        padding: 15px 55px;
        border: none;
        border-radius: 7px;
        background-color: var(--buttons_color_2nd);
        color: var(--fonts_color_2nd);
        font-weight: 700;
    }
    .footer_modal .next:disabled, .footer_modal .previous:disabled{
        cursor: default;
        opacity: 0.5;
    }
    .text_detail textarea{
        font-family: Arial, Helvetica, sans-serif;
        width: 98%;
        border-radius: 5px;
        padding-top: 10px;
        padding-left: 10px;
        color: #1c1c1c90;
        resize: none;
    }
    .text_detail{
        margin:12px 0;
    }
    .text_count {
        float: right;
        font-size: 11px;
        color: #c7c9c9;
        margin-top: 17px;
    }
    .text_modal {
        margin-top: 30px;
    }
    .text_title {
        font-weight: 700;
        font-size: 16px;
    }
    .type_selector {
        font-size: 10px;
        margin: 10px 0px;
        display: flex;
        justify-content: center;
    }
    .type_selector .selector_active {
        font-weight: 700;
        border-bottom: 2px solid #000;
    }
    .title_modal {
        font-weight: 700;
        font-size: 16px;
    }
    .body_modal {
        max-width: 600px;
        margin-top: 25px;
        margin-bottom: 25px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .header_modal {
        padding: 16px;
        line-height: 148.5%;
        background-color: var(--headers_color_2nd);
        text-align: center;
        font-size: 12px;
        color: var(--fonts_color_2nd);
        letter-spacing: 0.5em;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    .main_modal {
        background-color: #fff;
        border-radius: 10px;
        width: 408px;
        height: 506px;
        font-family: Arial, Helvetica, sans-serif;
    }
    .popup-position {
        position: relative;
        top: var(--headers_height);
        right: 10px;
        max-width: 350px;
        float: right;
        width: 80%;
        display: flex;
        flex-direction: column;
    }

    .notification {
        width: 100%;
        cursor: pointer;
        max-height: 100px;
        height: 20%;
        position: relative;
        margin: 10px 0;
        background: rgba(1, 1, 1, 0.5);
        padding: .5rem 1rem;
        float: right;
    }
    .popup-close{
        position: absolute;
        top: 3px;
        right: 10px;
        color: black;
        font-family: cursive;
    }

    .notification-img img {
        width: 100%
    }
    .notification-text{
        color: #e2e2e2;
    }
    .notification-text .notification-title {
        font-weight: 900;
    }
    .area-upload{
        margin: 20px auto;
        padding: 20px;
        box-sizing: border-box;
        
        width: 408px;
        min-width: 408px;
        min-height: 138px;
        position: relative;
    }
    .area-upload input{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        width: 90%;
        opacity: 0;
    }

    .area-upload .lista-uploads .barra{
        margin: 10px 0;
        width: 100%;
        position: relative;
    }

    .area-upload .lista-uploads .barra .fill{
        background-color: #a1f7ff;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        min-width: 0;
        
        -webkit-transition: .2s all;
        -moz-transition: .2s all;
        -o-transition: .2s all;
        transition: .2s all;
    }

    .area-upload .lista-uploads .barra.complete .fill{
        background-color: #bcffdf;
    }

    .area-upload .lista-uploads .barra .text{
        z-index: 10;
        text-align: center;
        padding: 3px 5px;
        box-sizing: border-box;
        position: relative;
        width: 100%;
        color: black;
        font-size: 12px;
    }
    .area-upload .lista-uploads .barra .text a{
        color: black;
        font-weight: bold;
    }

    .area-upload .lista-uploads .barra.error .fill{	
        background-color: #c02929;
        color: white;
        min-width: 100%;
    }

    .area-upload .lista-uploads .barra.error .text{
        color: white;
    }

    .area-upload label.label-upload{
        text-align: center;
        width: 328px;
        
        display: flex;
        justify-content: center;
        flex-direction: column;
        color: #1c1c1c80;
        position: relative;
        
        -webkit-transition: .3s all;
        -moz-transition: .3s all;
        -o-transition: .3s all;
        transition: .3s all;
    }

    .area-upload label.label-upload.highlight{
        background-color: #cccccc50;
    }

    .area-upload label.label-upload *{
        pointer-events: none;
    }
    @media screen and (max-width: 500px)
    {

    }
</style>